module.exports = __webpack_public_path__ + "img/closed.386f80e2.svg";